import React from 'react';

import {SettingIndentedRow} from '../components/SettingIndentedRow';
import {MediaSetting} from './types';

export const Subsettings = ({subsettings}: {subsettings: MediaSetting[]}) => {
  const renderedSubsettings = subsettings
    .map(({component: SubSettingComponent}, index) => {
      const content = <SubSettingComponent />;
      return content ? (
        <div className="pl-12 leading-4" key={index}>
          {content}
        </div>
      ) : null;
    })
    .filter(Boolean);

  if (renderedSubsettings.length === 0) {
    return null;
  }

  return (
    <SettingIndentedRow className="flex flex-col gap-8 first:pt-0">
      {renderedSubsettings}
    </SettingIndentedRow>
  );
};
